import type { Config } from '../../_config'
import type { UseCase } from '../../_kernel/architecture'
import type { Affiliate } from '../domain/Affiliate'
import type { SharedRepository } from '../domain/SharedRepository'
import { SharedRepositoryProxy } from '../infrastructure/SharedRepositoryProxy'

export default class GetCurrentAffiliateSharedUseCase implements UseCase<undefined, Affiliate> {
  static readonly USE_CASE_NAME = 'GetCurrentAffiliateSharedUseCase'
  static create({ config, repository }: { config: Config; repository?: SharedRepository }) {
    return new GetCurrentAffiliateSharedUseCase(
      repository ?? SharedRepositoryProxy.create({ config })
    )
  }

  constructor(private repository: SharedRepository) {}

  async execute() {
    return this.repository.affiliate()
  }
}
